import {Component, inject, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {FooterComponent} from './components/footer/footer.component';
import {HeaderComponent} from './components/header/header.component';
import {CookieStorageService} from './common/services/cookie-storage.service';
import { v4 } from 'uuid';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {

  _cookie = inject(CookieStorageService);



  ngOnInit() {
    this.setUserSessionIdentify();
  }



  setUserSessionIdentify() {
    if (!this._cookie.get('userSessionId')) {
      const userSessionId = v4().toString().replace(/-/g, '').substr(0, 16);
      this._cookie.set('userSessionId', userSessionId);
    }
  }

}
